import { Injectable, Injector } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { DomainService } from './services';

@Injectable()
export class DomainInterceptor implements HttpInterceptor {
    constructor(
        private injector: Injector,
    ) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const domainService = this.injector.get(DomainService);
        const domain = domainService.getDomain();
        const authReq = request.clone({
            setParams: {
                domain: `${domain}`
            }
        });
        return next.handle(authReq);
    }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/shared/domain.interceptor.ts